import { ScrollTrigger } from '../global/gsap';

const initScrollDirection = () => {
    const filterEl = document.querySelector('.js-event-filter');

    if (filterEl) {
        const observer = new IntersectionObserver(
            ([e]) => e.target.classList.toggle('is-sticky', e.intersectionRatio < 1),
            { threshold: [1] }
        );

        observer.observe(filterEl);
    }

    ScrollTrigger.create({
        trigger: document.body,
        invalidateOnRefresh: true,
        start: () => `top+=${window.innerHeight / 5} top`,
        onUpdate: (self) => {
            if (self.isActive) {
                if (self.direction === 1) {
                    document.body.classList.remove('scrolling-up');
                    document.body.classList.add('scrolling-down');
                } else {
                    document.body.classList.remove('scrolling-down');
                    document.body.classList.add('scrolling-up');
                }
            } else {
                document.body.classList.remove('scrolling-up', 'scrolling-down');
            }
        }
    });
};

export { initScrollDirection as default };
